import styled from 'styled-components';

const ContactsLinkStyle = styled.div`
	&.followUsCont {
		--linksMaxWidth: var(--sp40x);

		display: flex;
		justify-content: flex-end;

		.followUs {
			text-align: right;
			max-width: var(--linksMaxWidth);

			> span {
				opacity: 0;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--linksMaxWidth: 100%;

			justify-content: flex-start;

			.followUs {
				text-align: left;

				.followUsTitle {
					display: inline-block;
				}
			}
		}
	}
`;

export default ContactsLinkStyle;
